import { getCurrentLang } from '#user/lib/i18n'

const optionsDatesByPrecisions = {
  year: {
    year: 'numeric',
  },
  month: {
    year: 'numeric',
    month: 'long',
  },
  day: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
} as const

type DatePrecision = keyof typeof optionsDatesByPrecisions

export function localizeDateString (dateString: string) {
  const datePartsCount = dateString.replace(/^-/, '').split('-').length
  const datePrecision: DatePrecision = precisionByDatePartsCount[datePartsCount] || 'year'
  dateString = fillDateString(dateString, datePrecision)
  const date = new Date(dateString)
  const userLang = getCurrentLang()
  const preferredLocale = navigator.languages?.find(locale => locale.startsWith(`${userLang}-`)) || userLang
  // undefined is letting the browser define its own locale
  const resolvableLocale = isResolvableIntlLangageCode(preferredLocale) ? preferredLocale : undefined
  return date.toLocaleDateString(resolvableLocale, optionsDatesByPrecisions[datePrecision])
}

const precisionByDatePartsCount = {
  1: 'year',
  2: 'month',
  3: 'day',
} as const

const timezoneOffset = new Date().getTimezoneOffset()
const westHemisphere = Number.isInteger(timezoneOffset) && timezoneOffset > 0

function fillDateString (dateString: string, datePrecision: DatePrecision) {
  // The Date Object needs a defined day, even if a month precision will be displayed.
  // This adds a day placeholder when necessary, while working around time zone issues
  if (westHemisphere) {
    if (datePrecision === 'year') return `${dateString}-01-02`
    else if (datePrecision === 'month') return `${dateString}-02`
    else return `${dateString}T13:00:00Z`
  } else {
    if (datePrecision === 'year') return dateString
    else if (datePrecision === 'month') return `${dateString}-01`
    else return dateString
  }
}

function isResolvableIntlLangageCode (lang: string) {
  try {
    return new Intl.DateTimeFormat(lang)
  } catch (err) {
    if (err.name !== 'RangeError') throw err
    return false
  }
}
